/**
 *    @author: Andrew Sheen
 *    @since:  2021-02-21
 */


import { Injectable } from '@angular/core';

import { Router } from '@angular/router';
import {HttpClient} from "@angular/common/http";
import { ItemList } from '../_common/constant/item-list';
import { environment } from '../../environments/environment';
import { Code } from '../../refresh/service/constant';
import { City, CityName } from '../_common/constant/page-const';
import {LangChangeEvent } from '@ngx-translate/core';
import { InputData } from '../_common/data/input-data';
import { GAManager } from './ga-manager';

declare let gtag: any;
@Injectable()

export class InitLoader {
       constructor(private router: Router ,
                   private httpClient:HttpClient,
                   private itemList:ItemList,
                   private data:InputData ) {}

       public load(event: LangChangeEvent,gAManager:GAManager) {

            let lang = event['lang'];

            this.data.subject.language = lang;

            let trans = event.translations;

            this.itemList.setLangChange(trans.shared,trans.project);          

            let NotFound = trans.shared.notFound;
            let Unknown  = trans.shared.unknown;
            let NotApplicable = trans.shared.notApplicable;

            let url = environment.service_url +lang +".json";  
            
            this.httpClient.get(url)
            .subscribe( res =>{
                              if ( !res )  {
                                    this.errorPage(lang);
                                    return;
                              }

                              let countryList = res['countryList'];
                                  countryList.splice(2,0,[Code.NotFound,NotFound]);
                              this.itemList.countryList    = new Map<string,string>(countryList);

                              let isoCountryList = res['isoCountryList'];
                                  isoCountryList.splice(2,0,[Code.NotFound,NotFound]);
                              this.itemList.isoCountryList = new Map<string,string>(isoCountryList);
                                   

                              let  provinceList   = res['provinceList'];
                                   provinceList.unshift([Code.DIVIDER,""]);
                              this.itemList.provinceListForAddr = new Map<string,string>(provinceList);

                              provinceList.unshift([Code.NotApplicable,NotApplicable]);
                              this.itemList.provinceList = new Map<string,string>(provinceList);
                                   



                              let cityList = res['cityList'];

                                  cityList.push([City.NorthYork,CityName.NorthYork]);
                                  cityList.push([City.Scarborough,CityName.Scarborough]);
                                  cityList.push([City.EastYork,CityName.EastYork]);
                                  cityList.push([City.Etobicoke,CityName.Etobicoke]);
                                  cityList.push([City.York,CityName.York]);
                                  cityList.push([City.Waterloo,CityName.Waterloo]);
                                  
                                  cityList.push([City.Walkerton ,CityName.Walkerton]);
                                  cityList.push([City.Clinton   ,CityName.Clinton]);
                                  cityList.push([City.Fergus    ,CityName.Fergus]);
                                  cityList.push([City.Haliburton,CityName.Haliburton]);
                                  cityList.push([City.Georgetown,CityName.Georgetown]);
                                  cityList.push([City.Lindsay   ,CityName.Lindsay]);
                                  cityList.push([City.Almonte   ,CityName.Almonte]);
                                  cityList.push([City.Alliston  ,CityName.Alliston]);
                                  cityList.push([City.Simcoe    ,CityName.Simcoe]);
                                  cityList.push([City.Winchester,CityName.Winchester]);
                                  cityList.push([City.PortPerry ,CityName.PortPerry]);
                                  cityList.sort( (a,b)=> {
                                           return a[1] > b[1] ? 1 : -1;
                                  });
                            
                                  cityList.unshift(['-2','']);
                                  cityList.unshift([Code.Unknown,Unknown]);
                                  cityList.unshift([Code.NotFound,NotFound]);

                              this.itemList.cityList = new Map<string,string>(cityList);
                              this.itemList.regionList = new Map<string,string>(res['regionList']);

                              this.itemList.hospitalList    = res['hospitalList'] ||{};
                              for ( let x in this.itemList.hospitalList ) {
                                    this.itemList.hospitalList[x].unshift([Code.NotFound,this.itemList.NotFoundDesc]);
                                    this.itemList.hospitalList[x] =  new Map<string,string>(this.itemList.hospitalList[x]);
                              }
                                  
                              this.itemList.birthCenterList = res['birthCenterList']||{};
                              for ( let x in this.itemList.birthCenterList ) {
                                    this.itemList.birthCenterList[x].unshift([Code.NotFound,this.itemList.NotFoundDesc]);
                                    this.itemList.birthCenterList[x] =  new Map<string,string>(this.itemList.birthCenterList[x]);
                              }

                              this.itemList.promoterList    = res['promoterListByCategory'];
                              for ( let x in this.itemList.promoterList ) {
                                    this.itemList.promoterList[x] =  new Map<number,string>(this.itemList.promoterList[x]);
                              }

                              this.itemList.categoryList = new Map<string,string>(res['categoryList']);
                              this.itemList.categoryDescList = res['categoryDescList'] ||{};

                              this.itemList.productFeeList = new Map<string,string>(res['productFeeList'] ||{});

                              this.itemList.geoCodeList   = res['geoCodeList'] ||{};
                              this.itemList.geoCodeNameList = res['geoCodeNameList'] ||{};
                              ////this.itemList.divisionRegistrarMap = res['divisionRegistrarMap'] ||{};
                              ////this.itemList.jurisdictionList = res['jurisdictionList'] ||{};
                              this.itemList.facilityList    = res['facilityList'] ||{};

                              this.data.subject.siteKey = res['siteKey'];

                              gtag('js', new Date());
                              gtag('config', res['trackingId']);

                              gAManager.send("/start");

                              ///console.log("***initData.loaded***");
                        },
                        error => {
                              //console.log(error);
                              this.errorPage(lang);
                        }
                      );
       }

       private errorPage(lang:string) {

            this.data.subject.hasError = true;
       }
}